import { all, call } from 'redux-saga/effects';

import { domainEvents, notifications, trainer } from './ui';
import { backendRootSaga } from './backend';

export default function* rootSaga(): Generator {
    yield all([...domainEvents, ...trainer, ...notifications, call(backendRootSaga)]);
}
